import _HomePage from "@/components/HomePage/modules.js"
import _Mine from "@/components/Mine/modules.js"

var routes = [{
		path: "",
		asyncComponent: () => import("@/components/HomePage/Dashboard.vue"),
		showAppBar: false,
		title: "老板看账",
		browserHistory: true,
		meta: {
			permission: false,
		}
	},
	{
		path: "/login/",
		asyncComponent: window.lm_env == 'jz'? () => import("@/components/Login/LoginJz.vue"): () => import("@/components/Login/LoginDz.vue"),
		showAppBar: false,
		title: "手机登录",
		meta: {
			permission: false,
		}
		// browserHistory: true
	},
	{
		path: "/loginConfirmation/",
		asyncComponent:  () => import("@/components/Login/LoginConfirmation.vue"),
		showAppBar: false,
		title: "手机登录",
		meta: {
			permission: false,
		}
		// browserHistory: true
	},
	{
		path: "/mine/",
		asyncComponent: () => import("@/components/Mine/MineHomePage.vue"),
		showAppBar: false,
		title: "我的",
		browserHistory: true,
		meta: {
			permission: false,
		},
	},
	{
		path: "/userInfo/",
		asyncComponent: () => import("@/components/Mine/UserInfo.vue"),
		showAppBar: false,
		title: "账号设置",
		browserHistory: true
	},
	{
		path: "/userName/",
		asyncComponent: () => import("@/components/Mine/UserName.vue"),
		showAppBar: false,
		title: "昵称",
		browserHistory: true
	},
	{
		path: "/errorPage/",
		asyncComponent: () => import("@/components/commons/ErrorPage.vue"),
		showAppBar: false,
		browserHistory: false
	},
]
window.block = true;

function addHook(modules) {
	for (var i = 0; i < modules.length; i++) {
		var m = modules[i];
		// m['beforeEnter'] = [checkLogin, checkPermission];
		var oo = m.options || {};
		m['options'] = Object.assign(oo, {
			browserHistory: true
		});
	}
	routes.push(...modules);
}

addHook(_HomePage);
addHook(_Mine);


export default routes
